<template>
  <v-main>
    <audio id="scanmobile-sound"><source src="./../../../assets/snd/scannerbeep.mp3" type="audio/mp3"></audio>
    <v-container grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <h1 class="mb-4">{{ ct.TitleText }}</h1>
          <v-progress-linear v-if="loading" :indeterminate="true" ></v-progress-linear>
          <v-card v-else raised>
            <v-card-text>
              <v-form ref="form" v-model="valid">
                <v-select v-if="!isHide('Facility')" :readonly="readonlyFacility" :items="form.facilities" v-model="form.facilityNo" @change="facilityChanged" :label="$t('Facility')" :rules="(isRequired('Facility') ? [rules.required] : [])"></v-select>

                <v-autocomplete
                  v-if="!isHide('Vehicle')" :readonly="isReadonly('Vehicle')" :items="form.vehicles" v-model="form.vehicleNo" @change="vehicleChanged" v-on:keyup="searchVehicle = $event.target.value" @keyup="searchDelayed" :label="$t('Vehicle')" :rules="isRequired('Vehicle') ? [rules.required] : []"  @focus="focusVehicle" :no-data-text="ct.NoDataAvailable">
                  <!-- <template v-slot:append><v-btn v-if="!disableCreateVehicle" @click="newVehicleNo = (form.vehicles.length === 0 ? searchVehicle : ''); newVehicleDialog = true" color="primary" icon class="mb-n1 mr-n1"><v-icon>add</v-icon></v-btn></template> -->
                </v-autocomplete>
                <v-progress-linear v-if="searching" :indeterminate="true" class="mt-n6"></v-progress-linear>

                <v-autocomplete v-if="!isHide('Agreement')" :readonly="isReadonly('Agreement')" :items="form.agreements" v-model="form.agreementNo" :label="$t('Agreement')" @change="agreementChanged" v-on:keyup="searchAgreement = $event.target.value" @keyup="searchDelayedAgreement" :rules="(isRequired('Agreement') ? [rules.required] : [])"></v-autocomplete>
                <v-autocomplete v-if="!isHide('Delivery')" :readonly="isReadonly('Delivery')" :items="form.deliveries" v-model="form.deliveryNo" :label="$t('Delivery')" @change="deliveryChanged" :disabled="!form.agreementNo" :rules="(isRequired('Delivery') ? [rules.required] : [])" :no-data-text="ct.NoDataAvailable"></v-autocomplete>
                <v-autocomplete v-if="!isHide('Customer')" :readonly="isReadonly('Customer')" :items="form.customers" v-model="form.customerNo" v-on:keyup="searchCustomer = $event.target.value" @keyup="searchDelayedCustomer" :label="$t('Customer')" :rules="(isRequired('Customer') ? [rules.required] : [])"></v-autocomplete>
                <v-autocomplete v-if="!isHide('Article')" :readonly="isReadonly('Article')" :items="form.articles" v-model="form.articleNo" @change="articleChanged" :label="$t('Article')" :rules="(isRequired('Article') ? [rules.required] : [])"></v-autocomplete>
                <v-autocomplete v-if="!isHide('Carrier')" :readonly="isReadonly('Carrier')" :items="form.carriers" v-model="form.carrierNo" :label="$t('Carrier')" :rules="(isRequired('Carrier') ? [rules.required] : [])"></v-autocomplete>
                <v-text-field v-if="!isHide('RequisitionNo1')" :readonly="isReadonly('RequisitionNo1')" v-model="form.requisitionNo1" :label="$t('RequisitionNo1')" :rules="(isRequired('RequisitionNo1') ? [rules.required] : [])"></v-text-field>
                <v-text-field v-if="!isHide('RequisitionNo2')" :readonly="isReadonly('RequisitionNo2')" v-model="form.requisitionNo2" :label="$t('RequisitionNo2')" :rules="(isRequired('RequisitionNo2') ? [rules.required] : [])"></v-text-field>
                <v-autocomplete v-if="!isHide('Plant')" :readonly="isReadonly('Plant')" :items="form.plants" v-model="form.plantNo" :label="$t('Plant')" :rules="(isRequired('Plant') ? [rules.required] : [])"></v-autocomplete>
                <v-text-field v-if="!isHide('Comment')" :readonly="isReadonly('Comment')" v-model="form.comment1" :label="$t('Comment')" :maxlength="100" :rules="(isRequired('Comment') ? [rules.required] : [])"></v-text-field>
                <v-combobox chips multiple deletable-chips hide-selected v-model="form.ScannedData" :label="$t('Scan')" :items="form.ScannedData" :item-text="item => item.articleNo + ' - ' + item.articleName + ' (' + item.kg + ' kg) [' + item.regNo + ']'" @change="scanChanged()" v-on:keyup="searchScan = $event.target.value" v-on:keypress="isNumber()" :rules="[rules.required]"></v-combobox>
                <v-flex xs12>
                  <v-data-table hide-default-footer dense
                    :headers="translatedHeaders()"
                    :items="form.ScannedGroup"
                    :items-per-page="100"
                    class="elevation-1">
                      <template v-slot:[`item.articleNo`]="{ item }">
                        <v-chip small :color="getArticeNoColor(item)" dark>
                          {{ item.articleNo }}
                        </v-chip>
                      </template>
                      <template v-slot:[`item.articleName`]="{ item }">
                        <v-flex class="font-weight-bold">
                          {{ item.articleName }}
                        </v-flex>
                      </template>
                      <template v-slot:[`item.kg`]="{ item }">
                        <v-flex class="font-weight-bold">
                          {{ item.kg }}
                        </v-flex>
                      </template>
                      <template v-slot:[`item.tare`]="{ item }">
                        <v-flex class="font-weight-bold">
                          {{ item.tare }}
                        </v-flex>
                      </template>
                      <template v-slot:[`item.count`]="{ item }">
                        <v-flex class="font-weight-bold">
                          <v-btn
                            @click="$root.$message.showSuccess(item)"
                          >button</v-btn>
                        </v-flex>
                      </template>
                      <template slot="body.append">
                        <tr>
                          <td class="grey lighten-2">{{$t('Gross')}} {{sumField('tare')+sumField('kg')}} kg</td>
                        </tr>
                      </template>
                  </v-data-table>
                </v-flex>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-flex xs12 text-right>
              <v-spacer></v-spacer>
              <v-btn v-if="openScanButton" class="mr-1 mb-1" @click="showScan" :color="'primary'">
                {{$t("Scan")}} {{buttonAppend}}{{smReg.comment ? ' (' + smReg.comment + ')' : ''}}
              </v-btn>
              <v-btn class="mr-1 mb-1" :loading="saving" min-width="97px" :disabled="!valid" @click="save('gotoRegistrations')" color="success">{{ct.SaveBtnText}} {{buttonAppend}}</v-btn>
              <v-btn class="mr-1 mb-1" color="primary" @click="preventLeave = false; $router.push({ name: redirectTo })">{{$t("Cancel")}}</v-btn>
              </v-flex>
            </v-card-actions>
          </v-card>
        </v-flex>

        <!-- SCAN DIALOG -->
        <v-dialog v-model="showScanDialog" max-width="600" @keydown.esc="showScanDialog = false" persistent>
          <v-card>
          <v-card-title class="headline bm=2" primary-title>
              {{$t("Scan barcodes")}}: {{form.ScannedData.length}}
          </v-card-title>
          <v-container fluid grid-list-md >
              <v-layout row wrap>
              <v-flex xs12 md12>
                <v-layout v-if="!isCameraLoaded && videoReady" row justify-center align-center>
                  <v-icon size="200" color="warning">videocam</v-icon>
                  {{this.$t('Barcode camera loading...')}}
                </v-layout>
                <StreamBarcodeReader v-if="videoReady" id="video" @decode="onBarcodeDecode" @error="onQrError" @loaded="onQrLoaded"></StreamBarcodeReader>
                <v-layout v-if="!videoReady" row justify-center align-center>
                  <v-icon size="200" color="error">warning</v-icon>
                  {{this.$t('Barcode camera error')}}
                </v-layout>
              </v-flex>
              </v-layout>
          </v-container>
          <v-divider></v-divider>
          <v-card-actions>
              <v-container fluid grid-list-md  style="padding: 0px 0px 0px 14px">
              <v-layout row wrap>
                  <v-flex xs12 md9>
                  <v-flex d-flex xs12 >{{$t("Scan")}}: {{form.ScannedData.map(s => s.regNo).join(', ')}}</v-flex>
                  </v-flex>
                  <v-flex xs12 md3 align-self-center>
                  <v-btn color="success" @click="showScanDialog = false; isCameraLoaded = false; videoReady = false">{{$t("Leave")}}</v-btn>
                  </v-flex>
              </v-layout>
              </v-container>
          </v-card-actions>
          </v-card>
        </v-dialog>

      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
import { app } from '@/main'
import * as Archive from '@/core/archive'
import * as ScanMobile from '@/modules/scan-mobile/scan-mobile'
import ct from '@/core/mixins/common-translations'
import rules from '@/core/mixins/common-rules'
import preventLeave from '@/core/mixins/preventLeave'
import * as LocalStorage from '@/core/local-storage'
import * as Security from '@/core/security'
import { StreamBarcodeReader } from 'vue-barcode-reader'
import { validSearchKeyUp } from '@/core/utils'
// import scannerbeep from '@/assets/snd/scannerbeep.mp3'

export default {
  components: {
    StreamBarcodeReader
  },
  mixins: [ct, rules, preventLeave],
  data: () => ({
    dataType: 'scan-mobile-scan',
    loading: true,
    saving: false,
    valid: true,
    readonlyFacility: true, // Prevent errors: true when editing registration, false when creating new registration
    hiddenFields: [],
    readonlyFields: [],
    requiredFields: [],
    redirectTo: 'scan-mobile-deliveries',
    redirectToEdit: 'edit-scan-mobile-scan',
    searchVehicle: '',
    searchCustomer: '',
    searchAgreement: '',
    searchScan: '',
    searchTimer: null,
    searching: false,
    newVehicleNo: null,
    newVehicleName: null,
    newVehicleLicensePlateNo: null,
    showScanDialog: false,
    videoReady: true,
    openScanButton: false,
    isCameraLoaded: false,
    isDecoding: false,
    form: {
      facilities: [],
      articles: [],
      agreements: [],
      deliveries: [],
      customers: [],
      vehicles: [],
      plants: [],
      carriers: [],
      ScannedData: [],
      facilityNo: '',
      articleNo: '',
      agreementNo: '',
      deliveryNo: '',
      carrierNo: '',
      customerNo: '',
      vehicleNo: '',
      vehicleLicensePlateNo: '',
      requisitionNo1: '',
      requisitionNo2: '',
      comment1: '',
      plantNo: '',
      scannedGroup: [],
      vehicleTare: 0,
      searchCriteria: '',
      top: 100
    },
    // scannings: [],
    id: undefined, // for Create/Edit support in TitleText
    smReg: {
      id: '00000000-0000-0000-0000-000000000000',
      registrationId: '00000000-0000-0000-0000-000000000000',
      facilityNo: null,
      finishedDate: null,
      finishedBy: null,
      comment: null,
      reg: null
    },
    headers: [
      { text: 'ArticleNo', value: 'articleNo' },
      { text: 'ArticleName', value: 'articleName' },
      { text: 'WeightNet', value: 'kg' },
      { text: 'Tare', value: 'tare' },
      { text: 'Amount delivered', value: 'count', customElement: 'countEdit' }
    ]
  }),
  computed: {
  },
  methods: {
    sumField (key) {
      // sum data in give key (property)
      return this.form.ScannedGroup.reduce((a, b) => a + (b[key] || 0), 0)
    },
    showScan () {
      this.isCameraLoaded = false
      this.videoReady = true
      this.save('saveAndScan')
    },
    translatedHeaders () {
      return this.headers.map(header => {
        const h = { ...header }
        h.text = this.$t(header.text)
        return h
      })
    },
    getArticeNoColor (item) {
      const index = this.form.ScannedGroup.indexOf(item)
      if (index % 6 === 1) return 'green'
      if (index % 6 === 2) return 'blue'
      if (index % 6 === 3) return 'orange'
      if (index % 6 === 4) return 'cyan'
      if (index % 6 === 5) return 'purple'
      return 'red'
    },
    groupScanned () {
      const scanned = {}
      const regs = {}
      this.form.ScannedData.forEach((item) => {
        if (item.regNo) {
          regs[item.regNo] = { regNo: item.regNo, id: item.id, articleNo: item.articleNo, articleName: item.articleName, kg: item.kg, tare: item.tare }
          if (!scanned[item.articleNo]) {
            scanned[item.articleNo] = { articleNo: item.articleNo, articleName: item.articleName, kg: item.kg, tare: item.tare, count: 1 }
          } else {
            scanned[item.articleNo].kg = scanned[item.articleNo].kg + item.kg
            scanned[item.articleNo].tare = scanned[item.articleNo].tare + item.tare
            scanned[item.articleNo].count = scanned[item.articleNo].count + 1
          }
        }
      })
      this.form.ScannedGroup = Object.values(scanned)
      this.form.ScannedData = Object.values(regs).sort()
    },
    async onManuallyDecode (scanXRegNo) {
      // Play a beep also on iPad
      const myAudio = document.getElementById('scanmobile-sound')
      myAudio.play()
      if (scanXRegNo && !this.isDecoding && scanXRegNo.length < 11 && this.isNumber(scanXRegNo)) {
        this.isDecoding = true
        this.form.ScannedData.pop(scanXRegNo)
        if (!this.form.ScannedData.map(s => s.regNo).includes(scanXRegNo)) {
          const res = await ScanMobile.loadScanXRegistration({ Facility: this.form.facilityNo, ScanXRegNo: scanXRegNo })
          if (!res.failed) {
            const res2 = await ScanMobile.isUsedRegistration({ Facility: this.form.facilityNo, ScanXRegNo: scanXRegNo })
            if (!res2.failed && !res2.data) {
              const scannedObject = { regNo: scanXRegNo, id: res.data.Id, articleNo: res.data.ArticleNo, articleName: res.data.ArticleName, kg: res.data.WeightNet, tare: res.data.WeightSecond }
              this.form.ScannedData.push(scannedObject)
              this.save('saveAndSearch') // auto save when manually entering, so no regs get lost after ex. page reload
              this.$root.$message.showSuccess(this.$t('Saved'))
            } else if (!res2.failed && res2.data) this.$root.$message.showError(this.$t('Barcode already scanned') + ' (' + this.$t('Reg.No.') + ' ' + res2.data.ParentRegistrationNo + '). ' + this.$t('ScanXRegNo') + ': ' + scanXRegNo)
          } else this.$root.$message.showError(this.$t('Data does not exist') + '. ' + this.$t('ScanXRegNo') + ': ' + scanXRegNo)
        }
      } else this.$root.$message.showError(this.$t('Barcode error') + '. (' + scanXRegNo + ')')
      this.searchScan = ''
      this.groupScanned()
      this.isDecoding = false
    },
    async onBarcodeDecode (scanXRegNo) {
      // Play a beep also on iPad
      const myAudio = document.getElementById('scanmobile-sound')
      myAudio.play()
      if (this.showScanDialog && !this.isDecoding && this.isNumber(scanXRegNo)) {
        this.isDecoding = true
        if (scanXRegNo) {
          if (!this.form.ScannedData.map(s => s.regNo).includes(scanXRegNo)) {
            const res = await ScanMobile.loadScanXRegistration({ Facility: this.form.facilityNo, ScanXRegNo: scanXRegNo })
            if (!res.failed) {
              const res2 = await ScanMobile.isUsedRegistration({ Facility: this.form.facilityNo, ScanXRegNo: scanXRegNo })
              if (!res2.failed && !res2.data) {
                const scannedObject = { regNo: scanXRegNo, id: res.data.Id, articleNo: res.data.ArticleNo, articleName: res.data.ArticleName, kg: res.data.WeightNet, tare: res.data.WeightSecond }
                this.form.ScannedData.push(scannedObject)
                this.save('saveAndScan') // auto save when scanning so no regs get lost after ex. page reload
                this.groupScanned()
                this.$root.$message.showSuccess(this.$t('Saved'))
              } else if (!res2.failed && res2.data) this.$root.$message.showError(this.$t('Barcode already scanned') + ' (' + this.$t('Reg.No.') + ' ' + res2.data.ParentRegistrationNo + '). ' + this.$t('ScanXRegNo') + ': ' + scanXRegNo)
            } else this.$root.$message.showError(this.$t('Data does not exist') + '. ' + this.$t('ScanXRegNo') + ': ' + scanXRegNo)
          }
        } else this.$root.$message.showError(this.$t('Barcode error') + '. (' + scanXRegNo + ')')
        this.isDecoding = false
      }
    },
    onQrError (val) {
      this.$root.$message.showError(this.$t('Barcode camera error') + '. (' + val + ')')
    },
    onQrLoaded (val) {
      this.isCameraLoaded = true
    },
    testVideo () {
      const video = document.getElementById('video')
      navigator.mediaDevices.getUserMedia({
        video: true
      }).then(
        stream => {
          this.$root.$message.showSuccess(video ?? this.$t('Barcode camera detected'))
          this.videoReady = true
          this.openScanButton = true
        },
        err => {
          this.$root.$message.showError(this.$t('Barcode camera error') + '. (' + err + ')')
          this.videoReady = false
        }
      )
    },
    searchDelayed (val) {
      // Only normal/Backspace/Delete keys must start a search
      if (validSearchKeyUp(val.keyCode)) {
        if (this.searchTimer) clearTimeout(this.searchTimer)
        this.searchTimer = setTimeout(this.searchVehicles, 600)
      }
    },
    searchDelayedCustomer (val) {
      // Only normal/Backspace/Delete keys must start a search
      if (validSearchKeyUp(val.keyCode)) {
        if (this.searchTimer) clearTimeout(this.searchTimer)
        this.searchTimer = setTimeout(this.searchCustomers, 600)
      }
    },
    searchDelayedAgreement (val) {
      // Only normal/Backspace/Delete keys must start a search
      if (validSearchKeyUp(val.keyCode)) {
        if (this.searchTimer) clearTimeout(this.searchTimer)
        this.searchTimer = setTimeout(this.searchAgreements, 600)
      }
    },
    searchVehicles () {
      if (this.searchVehicle.length < 1) this.form.vehicles = []
      // Temporary show Search vehicle xxx ....
      this.form.vehicles = [this.searchVehicle.length ? this.$t('Searching') + ' ' + this.searchVehicle + ' ...' : this.$t('Search')]
      // Only update if not already searching and serarch text is entered
      if (!this.searching && this.searchVehicle) this.updateVehicles(this.searchVehicle)
    },
    searchCustomers () {
      if (this.searchCustomer.length < 1) this.form.customers = []
      // Temporary show Search customer xxx ....
      this.form.customers = [this.searchCustomer.length ? this.$t('Searching') + ' ' + this.searchCustomer + ' ...' : this.$t('Search')]
      // Only update if not already searching and serarch text is entered
      if (!this.searching && this.searchCustomer) this.updateCustomers(this.searchCustomer)
    },
    searchAgreements () {
      if (this.searchAgreement.length < 1) this.form.agreements = []
      // Temporary show Search agreement xxx ....
      this.form.agreements = [this.searchAgreement.length ? this.$t('Searching') + ' ' + this.searchAgreement + ' ...' : this.$t('Search')]
      // Only update if not already searching and serarch text is entered
      if (!this.searching && this.searchAgreement) this.updateAgreements(this.searchAgreement)
    },
    focusVehicle () {
      // Temporary show Search
      if (this.form.vehicles.length !== 1) this.form.vehicles = [this.$t('Search')]
    },
    async updateVehicles (search) {
      this.searching = true

      // "search" for one vehicle (single lookup)
      if (search.length === 1) {
        const res = await Archive.loadVehicle({ facilityNo: this.form.facilityNo, vehicleNo: search })
        if (!res.failed) {
          if (res.data) {
            const item = res.data
            this.form.vehicles = [{
              text: [item.No, item.LicensePlateNo].filter(Boolean).join(' - '),
              value: item.No,
              obj: item
            }]
            // load Tare when vehicle is unique
            if (this.form.vehicles.length === 1) this.form.vehicleTare = Math.round(item.Details.find(o => o.Name === 'TareWeight')?.Value ?? 0)
          } else {
            this.form.vehicles = []
            this.form.vehicleTare = 0
          }
        }
      } else { // search for many vehicles (via searchText)
        const res = await ScanMobile.loadVehicles({ facility: this.form.facilityNo, searchText: search })
        if (!res.failed) {
          this.form.vehicles = res.data.map(item => {
            return {
              text: [item.No, item.LicensePlateNo].filter(Boolean).join(' - '),
              value: item.No,
              obj: item
            }
          })
          // load Tare when vehicle is unique
          if (this.form.vehicles.length === 1) this.form.vehicleTare = Math.round(res.data.Details.find(o => o.Name === 'TareWeight')?.Value ?? 0)
        }
      }
      this.sumField('kg')
      this.sumField('tare')
      this.searching = false
    },
    async updateCustomers (search) {
      this.searching = true
      const res = await Archive.loadCustomers({ facilityNo: this.form.facilityNo, searchCriteria: search, top: this.form.top })
      if (!res.failed) {
        this.form.customers = res.data.map(item => {
          return {
            text: [item.No, item.Name].filter(Boolean).join(' - '),
            value: item.No,
            obj: item
          }
        })
      }

      this.searching = false
    },
    async updateAgreements (search) {
      this.searching = true
      const res = await Archive.loadAgreements({ facilityNo: this.form.facilityNo, searchCriteria: search, top: this.form.top, agreementNoFilter: this.agreementNoFilter })
      if (!res.failed) {
        this.form.agreements = res.data.map(item => {
          return {
            text: [item.No, item.Name].filter(Boolean).join(' - '),
            value: item.No,
            obj: item
          }
        })
      }

      this.searching = false
    },
    async loadVehicle (search, changeVehicle) {
      const res = await Archive.loadVehicle({ facilityNo: this.form.facilityNo, vehicleNo: search })
      if (!res.failed) {
        if (res.data) {
          const item = res.data
          this.form.vehicles = [{
            text: [item.No, item.LicensePlateNo].filter(Boolean).join(' - '),
            value: item.No,
            obj: item
          }]
          // load Tare when vehicle is unique
          if (this.form.vehicles.length === 1) this.form.vehicleTare = Math.round(res.data.Details.find(o => o.Name === 'TareWeight')?.Value ?? 0)
          if (changeVehicle) this.vehicleChanged() // so all reference fields are updated
          if (!changeVehicle) { // on edit: filtered agreements are loaded (Valid Choice)
            this.agreementNoFilter = this.getData1FromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'ValidAgreements')
            this.loadAgreement(this.form.agreementNo)
          }
        }
      }
    },
    async loadAgreement (number) {
      const res = await Archive.loadAgreement({ facilityNo: this.form.facilityNo, no: number, searchCriteria: null, top: this.form.top, agreementNoFilter: this.agreementNoFilter })
      if (!res.failed) {
        this.form.agreements = res.data.map(item => {
          return {
            text: [item.No, item.Name].filter(Boolean).join(' - '),
            value: item.No,
            obj: item
          }
        })
      }
    },
    async updateUi () {
      this.form.facilities = [this.$t('Loading ...')]
      this.form.agreements = [this.$t('Loading ...')]
      this.form.deliveries = [this.$t('Loading ...')]
      this.form.customers = [this.$t('Loading ...')]
      this.form.articles = [this.$t('Loading ...')]
      this.form.carriers = [this.$t('Loading ...')]
      this.form.plants = [this.$t('Loading ...')]

      let res = await Archive.loadFacilities(true)
      if (!res.failed) {
        const noGlobal = res.data.filter(o => o.No !== '')
        this.form.facilities = noGlobal.map(item => {
          return {
            text: item.No,
            value: item.No,
            obj: item
          }
        })
      }

      res = await Archive.loadCarriers(this.form.facilityNo)
      if (!res.failed) {
        this.form.carriers = res.data.map(item => {
          return {
            text: [item.No, item.Name].filter(Boolean).join(' - '),
            value: item.No,
            obj: item
          }
        })
      }

      res = await Archive.loadPlants(this.form.facilityNo)
      if (!res.failed) {
        this.form.plants = res.data.map(item => {
          return {
            text: [item.No, item.Name].filter(Boolean).join(' - '),
            value: item.No,
            obj: item
          }
        })
      }

      this.form.searchCriteria = this.form.customerNo
      res = await Archive.loadCustomers({ facilityNo: this.form.facilityNo, searchCriteria: this.form.searchCriteria, top: this.form.top })
      if (!res.failed) {
        this.form.customers = res.data.map(item => {
          return {
            text: [item.No, item.Name].filter(Boolean).join(' - '),
            value: item.No,
            obj: item
          }
        })
      }

      res = await Archive.loadArticles(this.form.facilityNo)
      if (!res.failed) {
        this.form.articles = res.data.map(item => {
          return {
            text: [item.No, item.Name].filter(Boolean).join(' - '), // https://stackoverflow.com/a/19903063
            value: item.No,
            obj: item
          }
        })
      }

      // Load only agreementNo into list
      this.form.searchCriteria = this.form.agreementNo
      res = await Archive.loadAgreement({ facilityNo: this.form.facilityNo, no: this.form.agreementNo, searchCriteria: null, top: this.form.top, agreementNoFilter: this.agreementNoFilter })
      if (!res.failed) {
        this.form.agreements = res.data.map(item => {
          return {
            text: [item.No, item.Name].filter(Boolean).join(' - '),
            value: item.No,
            obj: item
          }
        })
      }

      this.updateDeliveries()

      // Force validation of all fields to show requrired
      if (this.$refs.form && !this.$refs.form.validate()) this.valid = false

      this.$forceUpdate()
    },
    async updateDeliveries () {
      const res = await Archive.loadDeliveries({ facilityNo: this.form.facilityNo, agreementId: this.getItemFromArray(this.form.agreements, this.form.agreementNo, 'Id') })
      if (!res.failed) {
        this.form.deliveries = res.data.map(item => {
          return {
            text: [item.No, item.Name].filter(Boolean).join(' - '),
            value: item.No,
            obj: item
          }
        })
        // Clear old value if not in new deliveries
        if (!this.form.deliveries.find(d => d.value === this.form.deliveryNo)) this.form.deliveryNo = ''
      }
    },
    async facilityChanged () {
      this.preventLeave = false
      if (this.useFacilityDescription) {
        var facilityDisplay = this.form.facilitiesDisplay.find(f => f.value === this.form.facilityDisplay)
        if (facilityDisplay != null) {
          this.form.facilityNo = facilityDisplay.item.No
        }
      } else {
        this.form.facilityNo = this.form.facilityDisplay
      }
      if (this.form.facilityNo != null) LocalStorage.save('facilityNo', this.form.facilityNo)
      this.form.vehicleNo = ''
      this.form.requisitionNo1 = ''
      this.form.requisitionNo2 = ''
      this.form.plantNo = ''
      this.form.carrierNo = ''
      this.form.articleNo = ''
      this.form.customerNo = ''
      this.form.agreementNo = ''
      this.form.deliveryNo = ''

      this.updateUi()
    },
    async deliveryChanged () {
      this.preventLeave = false
      var requisitionNo1 = this.getValueFromArray(this.getItemFromArray(this.form.deliveries, this.form.deliveryNo, 'Details'), 'DelRequisitionNo')
      var requisitionNo2 = this.getValueFromArray(this.getItemFromArray(this.form.deliveries, this.form.deliveryNo, 'Details'), 'DelRequisitionNo2')
      var plantNo = this.getValueFromArray(this.getItemFromArray(this.form.deliveries, this.form.deliveryNo, 'Details'), 'DelPlantNo')
      var carrierNo = this.getValueFromArray(this.getItemFromArray(this.form.deliveries, this.form.deliveryNo, 'Details'), 'DelCarrierNo')
      var articleNo = this.getValueFromArray(this.getItemFromArray(this.form.deliveries, this.form.deliveryNo, 'Details'), 'DelArticleNo')
      var customerNo = this.getValueFromArray(this.getItemFromArray(this.form.deliveries, this.form.deliveryNo, 'Details'), 'DelCustomerNo')

      if (requisitionNo1) this.form.requisitionNo1 = requisitionNo1
      if (requisitionNo2) this.form.requisitionNo2 = requisitionNo2
      if (plantNo) this.form.plantNo = plantNo
      if (carrierNo) this.form.carrierNo = carrierNo
      if (articleNo) { this.form.articleNo = articleNo; this.articleChanged() }
      if (customerNo) { this.form.customerNo = customerNo; this.updateCustomers(customerNo) }

      this.$forceUpdate()
    },
    async agreementChanged () {
      this.preventLeave = false
      this.form.deliveries = [this.$t('Loading ...')]
      this.form.deliveryNo = ''
      var requisitionNo1 = this.getValueFromArray(this.getItemFromArray(this.form.agreements, this.form.agreementNo, 'Details'), 'RequisitionNo')
      var requisitionNo2 = this.getValueFromArray(this.getItemFromArray(this.form.agreements, this.form.agreementNo, 'Details'), 'RequisitionNo2')
      var plantNo = this.getValueFromArray(this.getItemFromArray(this.form.agreements, this.form.agreementNo, 'Details'), 'PlantNo')
      var carrierNo = this.getValueFromArray(this.getItemFromArray(this.form.agreements, this.form.agreementNo, 'Details'), 'CarrierNo')
      var articleNo = this.getValueFromArray(this.getItemFromArray(this.form.agreements, this.form.agreementNo, 'Details'), 'ArticleNo')
      var customerNo = this.getValueFromArray(this.getItemFromArray(this.form.agreements, this.form.agreementNo, 'Details'), 'CustomerNo')

      if (requisitionNo1) this.form.requisitionNo1 = requisitionNo1
      if (requisitionNo2) this.form.requisitionNo2 = requisitionNo2
      if (plantNo) this.form.plantNo = plantNo
      if (carrierNo) this.form.carrierNo = carrierNo
      if (articleNo) { this.form.articleNo = articleNo; this.articleChanged() }
      if (customerNo) { this.form.customerNo = customerNo; this.updateCustomers(customerNo) }

      this.updateDeliveries()
      this.$forceUpdate()
    },
    async vehicleChanged () {
      // Fix selecting "Search" by accident
      if ((!this.form.vehicleNo && this.form.vehicles.length !== 1) || (this.form.vehicleNo && this.form.vehicleNo.includes(this.$t('Search')))) {
        this.form.vehicles = []
        this.form.vehicleNo = ''
        this.searchVehicle = ''
      }

      this.preventLeave = false
      this.form.requisitionNo1 = ''
      this.form.requisitionNo2 = ''
      this.form.plantNo = ''
      this.form.carrierNo = ''
      this.form.articleNo = ''
      this.form.customerNo = ''
      this.form.agreementNo = ''
      this.form.deliveryNo = ''

      var requisitionNo1 = this.getValueFromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'RequisitionNo')
      var requisitionNo2 = this.getValueFromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'RequisitionNo2')
      var plantNo = this.getValueFromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'PlantNo')
      var carrierNo = this.getValueFromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'CarrierNo')
      var articleNo = this.getValueFromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'ArticleNo')
      var customerNo = this.getValueFromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'CustomerNo')
      var deliveryNo = this.getValueFromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'DeliveryNo')
      var agreementNo = this.getValueFromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'AgreementNo')
      this.agreementNoFilter = this.getData1FromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'ValidAgreements')

      if (requisitionNo1) this.form.requisitionNo1 = requisitionNo1
      if (requisitionNo2) this.form.requisitionNo2 = requisitionNo2
      if (plantNo) this.form.plantNo = plantNo
      if (carrierNo) this.form.carrierNo = carrierNo
      if (articleNo) { this.form.articleNo = articleNo; this.articleChanged() }
      if (customerNo) { this.form.customerNo = customerNo; this.updateCustomers(customerNo) }
      if (agreementNo) { this.form.agreementNo = agreementNo; this.agreementChanged() }
      if (deliveryNo) { this.form.deliveryNo = deliveryNo; this.deliveryChanged() }

      this.loadAgreement(this.form.agreementNo)

      this.$forceUpdate()
      LocalStorage.save('currentDelivVehicleNo', this.form.vehicleNo)
    },
    async articleChanged () {
      this.preventLeave = false
      var plantNo = this.getValueFromArray(this.getItemFromArray(this.form.articles, this.form.articleNo, 'Details'), 'PlantNo')
      if (plantNo) this.form.plantNo = plantNo
      this.$forceUpdate()
    },
    async scanChanged () {
      if (this.searchScan && this.searchScan.length < 11) {
        this.onManuallyDecode(this.searchScan) // auto save when manually add
      } else { // auto save when manually delete (cancelled)
        this.searchScan = ''
        this.groupScanned()
        this.save('saveAndSearch')
        this.$root.$message.showSuccess(this.$t('Cancelled'))
      }
    },
    async tst () {
      // this.$root.$message.showSuccess(this.$t("tst:"+this.form.article))
      /* console.log('---->> this.form.vehicleNo:', this.form.vehicleNo, this.form.articleNo)
      console.log('---->> LicensePlateNo:', this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'LicensePlateNo'))
      console.log('---->> Name:', this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Name'))
      console.log('---->> Art:', this.getItemFromArray(this.form.articles, this.form.articleNo, 'Name'))
      console.log('---->> Lists:', this.form.articles, this.form.vehicles) */
    },
    getItemFromArray (array, findNo, findPropertyName) {
      var result = null
      if (Array.isArray(array) && array.length) {
        // array exists and is not empty
        var found = array.find(o => o.obj.No === findNo)
        if (found) {
          // item exists
          result = found.obj[findPropertyName]
          // if property does not exist we return null
          if (result === undefined) result = null
        }
      }
      return result
    },
    getValueFromArray (array, findName) {
      var result = null
      if (Array.isArray(array) && array.length) {
        // array exists and is not empty
        var found = array.find(o => o.Name === findName)
        if (found) {
          // item exists
          result = found.Value
          // if property does not exist we return null
          if (result === undefined) result = null
        }
      }
      return result
    },
    getData1FromArray (array, findName) {
      var result = null
      if (Array.isArray(array) && array.length) {
        // array exists and is not empty
        var found = array.find(o => o.Name === findName)
        if (found) {
          // item exists
          result = found.Data1
          // if property does not exist we return null
          if (result === undefined) result = null
        }
      }
      return result
    },
    changeCount (event, articleNo, value) {
      this.form.ScannedGroup = this.form.ScannedGroup.map(item => item.articleNo === articleNo ? { ...item, count: event.target.value } : item)
    },
    isNumber: function (val) {
      val = (val) || window.event
      var charCode = (val.which) ? val.which : val.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
        val.preventDefault()
      } else {
        return true
      }
    },
    isHide (fieldName) {
      return this.hiddenFields.some(h => h === fieldName)
    },
    isReadonly (fieldName) {
      return this.readonlyFields.some(h => h === fieldName)
    },
    isRequired (fieldName) {
      return this.requiredFields.some(h => h === fieldName)
    },
    formToObject () {
      this.smReg.facilityNo = this.form.facilityNo

      if (!this.smReg.Registration) this.smReg.Registration = {}

      this.smReg.Registration.VehicleNo = this.form.vehicleNo
      this.smReg.Registration.VehicleName = this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Name')
      this.smReg.Registration.VehicleLicensePlateNo = this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'LicensePlateNo')
      this.smReg.Registration.AgreementNo = this.form.agreementNo
      this.smReg.Registration.AgreementName = this.getItemFromArray(this.form.agreements, this.form.agreementNo, 'Name')
      this.smReg.Registration.DeliveryNo = this.form.deliveryNo
      this.smReg.Registration.DeliveryName = this.getItemFromArray(this.form.deliveries, this.form.deliveryNo, 'Name')
      this.smReg.Registration.CustomerNo = this.form.customerNo
      this.smReg.Registration.CustomerName = this.getItemFromArray(this.form.customers, this.form.customerNo, 'Name')
      this.smReg.Registration.ArticleNo = this.form.articleNo
      this.smReg.Registration.ArticleName = this.getItemFromArray(this.form.articles, this.form.articleNo, 'Name')
      this.smReg.Registration.PlantNo = this.form.plantNo
      this.smReg.Registration.PlantName = this.getItemFromArray(this.form.plants, this.form.plantNo, 'Name')
      this.smReg.Registration.CarrierNo = this.form.carrierNo
      this.smReg.Registration.CarrierName = this.getItemFromArray(this.form.carriers, this.form.carrierNo, 'Name')
      this.smReg.Registration.RequisitionNo1 = this.form.requisitionNo1
      this.smReg.Registration.RequisitionNo2 = this.form.requisitionNo2
      this.smReg.Registration.Comment1 = this.form.comment1
    },
    async save (val) {
      // Pending Vehicle check to avoid Import/Export problems and because ScanX only supports ONE Vehicle pr. 1. weighing.
      if (this.$route.params.pendingVehicles !== undefined && this.$route.params.pendingVehicles.length && this.$route.params.pendingVehicles.some(p => p === this.form.vehicleNo)) {
        this.$root.$message.showError(this.$t('Vehicle') + ' ' + this.form.vehicleNo.toString() + ' ' + this.$t('has an unfinished registration. Please Finish or use another.'))
      } else {
        this.preventLeave = false
        if (this.$refs.form.validate() || this.form.ScannedData.length === 0) { // save also with empty ScannedData
          this.saving = true
          this.formToObject()
          const res = await ScanMobile.saveRegistration({
            Id: this.smReg.id,
            RegistrationId: this.smReg.registrationId,
            Facility: this.smReg.facilityNo,
            FinishedDate: this.smReg.finishedDate,
            FinishedBy: this.smReg.finishedBy,
            Comment: this.smReg.comment,
            Registration: this.smReg.Registration,
            RegistrationType: 1, // 1 = Deliveries
            ScannedData: JSON.stringify(this.form.ScannedData),
            ParentRegistrationNo: this.smReg.Registration.No
          })
          this.saving = false
          if (!res.failed) {
            this.preventLeave = false

            // After Save, jump back to Registrations or directly to Set Weight
            this.smReg.id = res.data.Id

            if (val === 'gotoRegistrations') {
              this.$router.push({ name: this.redirectTo })
              this.$root.$message.showSuccess(this.$t('Saved'))
            } else {
              if (!this.$route.params.id) this.$router.push({ name: this.redirectToEdit, params: { id: this.smReg.id } })
              // Open scan dialog only if Scan button is pressed, but not when user manually enters ScanXRegNos
              if (val === 'saveAndScan') this.showScanDialog = true
            }
          }
        }
      }
    }
  },
  watch: {
  },
  async mounted () {
    if (this.$route.params.pendingVehicles === undefined) {
      // Go back to Registrations
      this.$router.push({ name: this.redirectTo })
    }

    // We use next tick to ensure that app is initialized
    this.$nextTick(() => {
      app.$on('force-update', () => {
        // We need this to ensure that autoLogin re-renders component
        this.$forceUpdate()
      })
    })

    // Use Settings from cached user's corporatationDetails
    if (Security.user.corporationDetails) {
      const defaultHidden = 'RequisitionNo2,Plant,Carrier,Comment' // New fields default hidden LSV/MITH. Remember to also add new defaults in Settings.vue and Registrations.vue
      this.hiddenFields = (Security.user.corporationDetails.find(d => d.Name === 'ScanMobile_Deliv_Fields_Hidden')?.Data1 ?? defaultHidden).split(',')
      this.readonlyFields = (Security.user.corporationDetails.find(d => d.Name === 'ScanMobile_Deliv_Fields_ReadOnly')?.Data1 ?? '').split(',')
      this.requiredFields = (Security.user.corporationDetails.find(d => d.Name === 'ScanMobile_Deliv_Fields_Mandatory')?.Data1 ?? '').split(',')
      // this.disableCreateVehicle = Security.user.corporationDetails.find(d => d.Name === 'ScanMobile_Disable_CreateVehicle')?.Data1 === 'true' ?? false
    }

    if (this.$route.params.id) {
      this.readonlyFacility = true
      this.id = this.$route.params.id // for Create/Edit support in TitleText
      this.smReg.id = this.$route.params.id
      const res = await ScanMobile.loadRegistration(this.smReg.id)
      if (!res.failed) {
        this.form.facilityNo = res.data.Facility
        this.updateUi()
        this.form.vehicleNo = res.data.Registration.VehicleNo
        this.form.agreementNo = res.data.Registration.AgreementNo
        // Load only this vehicle into form.vehicles so LicensPlate is visible and dropdown works
        const changeVehicle = false // Do NOT change vehicle (and article)
        if (this.form.vehicleNo) { this.loadVehicle(this.form.vehicleNo, changeVehicle) } else this.form.vehicles = [this.$t('Search')]

        this.form.vehicleName = res.data.Registration.VehicleName
        this.form.vehicleLicensePlateNo = res.data.Registration.VehicleLicensePlateNo
        this.form.deliveryNo = res.data.Registration.DeliveryNo
        this.form.customerNo = res.data.Registration.CustomerNo
        this.form.articleNo = res.data.Registration.ArticleNo
        this.form.plantNo = res.data.Registration.PlantNo
        this.form.carrierNo = res.data.Registration.CarrierNo
        this.form.requisitionNo1 = res.data.Registration.RequisitionNo1
        this.form.requisitionNo2 = res.data.Registration.RequisitionNo2
        this.form.comment1 = res.data.Registration.Comment1
        this.form.ScannedData = JSON.parse(res.data.ScannedData)

        this.smReg.registrationId = res.data.RegistrationId
        this.smReg.facilityNo = res.data.Facility
        this.smReg.finishedDate = res.data.FinishedDate
        this.smReg.finishedBy = res.data.FinishedBy
        this.smReg.comment = res.data.Comment
        this.smReg.Registration = res.data.Registration
      }
    } else {
      this.readonlyFacility = this.isReadonly('Facility') // can be setup ReadOnly
      const storedFacilityNo = '' + LocalStorage.load('facilityNo')
      if (storedFacilityNo) {
        this.form.facilityNo = '' + LocalStorage.load('facilityNo')
      }
      this.updateUi()

      // Load current (stored) VehicleNo
      const currentDelivVehicleNo = LocalStorage.load('currentDelivVehicleNo')
      if (currentDelivVehicleNo) {
        this.form.vehicleNo = currentDelivVehicleNo.toString()
        const changeVehicle = true // Also change vehicle and article
        this.loadVehicle(currentDelivVehicleNo.toString(), changeVehicle) // When loaded also set ArticleNo from LocalStorage or if exists from Vehicle (and other fields from Vehicle)
      } else { LocalStorage.remove('currentDelivVehicleNo') }
    }

    this.testVideo()

    this.groupScanned()
    this.$nextTick(() => {
      this.loading = false
    })
  }
}
</script>

<style>
.tabel-input:focus {
    outline: none !important;
    border:1px solid red;
    box-shadow: 0 0 20px #719ECE;
}
.tabel-input {
    padding: 0px 0px 0px 5px;
    border:1px solid #719ECE;
    box-shadow: 0 0 10px #719ECE;
}

</style>
